import { gql } from 'graphql-request';
import { getGraphQLQueryClient } from './query-client';
import {
  Event,
  Nullable,
  UserWithToken,
  WithMeta,
} from '@ygoargentina/sdk/api/api.types';

/**
 * `Query.events` pagina por `filters: EventFilters` y devuelve un `EventList`
 * con los eventos adentro de `data`, no la lista pelada. El documento pedía los
 * campos del evento sobre el propio `EventList` y `page`/`limit` como
 * argumentos sueltos, así que la query se rechazaba entera (YGO-305).
 */
export const listEvents = async (
  user: Nullable<UserWithToken>,
  filters?: { page?: number; limit?: number }
) =>
  getGraphQLQueryClient(user).request<WithMeta<Event>>(
    gql`
      query listEvents($filters: EventFilters) {
        data: events(filters: $filters) {
          data {
            id
            title
            store {
              id
              name
            }
            dateFrom
            dateTo
            createdAt
          }
          meta {
            total
            page
            perPage
            lastPage
          }
        }
      }
    `,
    { filters }
  );

export const createEvent = async (
  user: Nullable<UserWithToken>,
  variables: Record<string, unknown>
) =>
  getGraphQLQueryClient(user).request<Event>(
    gql`
      mutation ($input: EventInput!) {
        createEvent(input: $input) {
          id
          title
          store {
            id
            name
          }
          dateFrom
          dateTo
          createdAt
        }
      }
    `,
    variables
  );
